import { ReactComponent as Logo } from "./../../../images/logo.svg";

const MainContentPlaceholder = () => {
  return (
    <div style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
      <Logo style={{height: "120px"}} />
    </div>
  );
};

export default MainContentPlaceholder;
